import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import RichText from "@/components/RichText";
import useSEO, { stripHtml } from "@/lib/seo";

const TITLES = {
  impressum: "Impressum",
  datenschutz: "Datenschutz",
  barrierefreiheit: "Barrierefreiheit",
};

export default function Legal({ slug }) {
  const [page, setPage] = useState(null);
  useEffect(() => { api.get(`/legal/${slug}`).then((r) => setPage(r.data)); }, [slug]);
  useSEO({
    title: page?.title || TITLES[slug] || "Rechtliches",
    description: stripHtml(page?.body, 200) || `${TITLES[slug] || "Rechtliche Hinweise"} zum Quartier am Hornschen Tor.`,
    path: `/${slug}`,
  });

  if (!page) return <div className="container-narrow py-24 text-sm text-neutral-500">Lade…</div>;

  return (
    <div className="container-narrow py-16 lg:py-24 max-w-3xl" data-testid={`legal-${slug}`}>
      <p className="text-xs uppercase tracking-[0.18em] text-[hsl(var(--brand-green-strong))] mb-4">Rechtliches</p>
      <h1 className="font-semibold text-4xl sm:text-5xl mb-8">{page.title}</h1>
      <RichText html={page.body} className="prose-quartier text-neutral-700" />
    </div>
  );
}
